import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import BPO from "../../components/Service/BPO";
import PageHeader from "../../components/ui/PageHeader";
import AnimatedPage from "../../components/ui/AnimatePage";
import Container from "../../components/ui/Container";
import { useIntroContext } from "../../hooks/useIntroContext";
import BlogList from "../../components/Blogs/BlogList";
import SuccessStoriesList from "../../components/Stories/SucessfulStoriesList";





const SucessfulStoriesPage: React.FC = () => {


  return (

        <Container>
            <SuccessStoriesList />

        </Container>





  );
};

export default SucessfulStoriesPage;

